import * as Sentry from '@sentry/react';

import { isProduction, sentryDsn } from './config';

if (isProduction) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.1,
    tracePropagationTargets: [
      'localhost',
      'localhost:5173',
      /^https:\/\/(?:[a-zA-Z0-9-]+\.)?playwall\.co(\/|$)/,
    ],
    tracesSampleRate: 1.0,
  });
}
